import { render, staticRenderFns } from "./ObjAutocomplete.vue?vue&type=template&id=b5db0cc2&"
import script from "./ObjAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ObjAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports